import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import UiInput from "../../../_uiComponents/UiInput";
import UiSelect from "../../../_uiComponents/common/form/UiSelect";
import {
     UiButton,
     UiToggleButton,
} from "../../../_uiComponents/common/form/UiButton";
import UiInnerSearchWr from "../../../_uiComponents/common/UiInnerSearchWr";
import UiMultipleSelect from "../../../_uiComponents/common/form/UiMultipleSelect";
import Validator from "../../../../_helpers/validate.schema";
import { incentiveTypesRequest } from "../../../../_redux/_actions";

import UiDateRangePicker from "../../../_uiComponents/common/form/UiDateRangePicker";

const validateSchema = () =>
     yup.object().shape({
          // name: yup.string().required("Name is required."),
          // type: yup.string().required("Type is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function IncentiveFilterForm(props) {
     const actionDispatch = useDispatch();
     const [pickerDates, setPickerDates] = useState({
          fromDate: "",
          toDate: "",
     });

     useEffect(() => {
          actionDispatch(incentiveTypesRequest());
     }, []);

     const { incentiveTypes } = useSelector((state) => {
          return {
               incentiveTypes: state.incentive.types,
          };
     });

     const setDatesFromPicker = (fromDate, toDate) => {
          setPickerDates({ fromDate: fromDate, toDate: toDate });
     };

     const submit = async (values) => {
          let typeIds = [];

          if (values.type) {
               typeIds = values.type.map((name) => {
                    let type = incentiveTypes.find(
                         (type) => type.name === name,
                    );
                    return type ? type.id : null;
               });
          }

          let payload = {
               application: values.application ?? "",
               typeIdList: typeIds,
               fromDate: pickerDates.fromDate ?? "",
               toDate: pickerDates.toDate ?? "",
               statusId: values.statusId,
          };

          props.getFilteredIncentiveList(payload);
     };

     return (
          <Form
               onSubmit={submit}
               validate={onValidate}
               render={({ form, handleSubmit }) => {
                    return (
                         <form onSubmit={validateSchema}>
                              <>
                                   <UiInnerSearchWr>
                                        <Grid container spacing={2}>
                                             <Grid item xs={12} lg={9}>
                                                  <Grid container spacing={2}>
                                                  <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiSelect
                                                                 label="Application"
                                                                 name="application"
                                                                 placeholder="Select option"
                                                                 options={[
                                                                      {
                                                                           id: 1,
                                                                           name: "All",
                                                                      },
                                                                      {
                                                                           id: 2,
                                                                           name: "Equipe",
                                                                      },
                                                                      {
                                                                           id: 3,
                                                                           name: "TLC",
                                                                      },
                                                                 ].map(
                                                                      (
                                                                           type,
                                                                      ) => {
                                                                           return {
                                                                                value: type.id,
                                                                                label: type.name,
                                                                           };
                                                                      },
                                                                 )}
                                                            />
                                                       </Grid>

                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiMultipleSelect
                                                                 name="type"
                                                                 label="Type"
                                                                 options={incentiveTypes.map(
                                                                      (row) => {
                                                                           return row.name;
                                                                      },
                                                                 )}
                                                            />
                                                       </Grid>

                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiDateRangePicker
                                                                 setDatesFromPicker={
                                                                      setDatesFromPicker
                                                                 }
                                                                 name="dateRangeInpt"
                                                            />
                                                       </Grid>

                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={4}
                                                       >
                                                            <UiSelect
                                                                 label="Status"
                                                                 name="statusId"
                                                                 placeholder="Select option"
                                                                 options={[
                                                                      {
                                                                           id: 1,
                                                                           name: "Scheduled",
                                                                      },
                                                                      {
                                                                           id: 2,
                                                                           name: "Ongoing",
                                                                      },
                                                                      {
                                                                           id: 3,
                                                                           name: "Completed",
                                                                      },
                                                                      {
                                                                           id: 4,
                                                                           name: "Disabled",
                                                                      },
                                                                 ].map(
                                                                      (
                                                                           type,
                                                                      ) => {
                                                                           return {
                                                                                value: type.id,
                                                                                label: type.name,
                                                                           };
                                                                      },
                                                                 )}
                                                            />
                                                       </Grid>
                                                  </Grid>
                                             </Grid>
                                             <Grid item xs={12} lg={3}>
                                                  <Stack
                                                       spacing={2}
                                                       direction="row"
                                                       justifyContent="end"
                                                       sx={{
                                                            width: "100%",
                                                            pt: 0.6,
                                                       }}
                                                  >
                                                       <UiButton
                                                            name="Clear"
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={() => {
                                                                 form.reset();
                                                                 submit({});
                                                            }}
                                                       />
                                                       <UiButton
                                                            name="Apply"
                                                            variant="contained"
                                                            size="small"
                                                            onClick={
                                                                 handleSubmit
                                                            }
                                                       />
                                                  </Stack>
                                             </Grid>
                                        </Grid>
                                   </UiInnerSearchWr>
                              </>
                         </form>
                    );
               }}
          />
     );
}
